import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME, POLOZKY } from './constants';
import { Pneu } from './store/types';

class PneuSkladProvider extends BaseApi {
	getPolozka(id: number) {
		return this.fetch(`/${DMS_MODULE}/${POLOZKY}/${id}`);
	}

	savePolozka(id: number, pneu: Pneu) {
		return this.update(`/${DMS_MODULE}/${POLOZKY}/${id}`, pneu);
	}

	createPolozka(pneu: Pneu) {
		return this.post(`/${DMS_MODULE}/${POLOZKY}/`, pneu);
	}

	getPneuDefault() {
		return this.fetch(`/${DMS_MODULE}/${POLOZKY}/Default`);
	}

	zmenaSkladPneu(pneuSklad: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaSkladPneu`, pneuSklad);
	}

	zmenaSkladMisto(pneuSklad: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaSkladMisto`, pneuSklad);
	}

	zmenaZakazka(pneuSklad: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaZakazka`, pneuSklad);
	}

	zmenaVozidlo(pneuSklad: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaVozidlo`, pneuSklad);
	}

	zmenaZakaznik(pneuSklad: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaZakaznik`, pneuSklad);
	}

	zmenaPracovnik(pneuSklad: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaPracovnik`, pneuSklad);
	}

	getPneuPredavaciProtokolReport(filter: {}) {
		return this.fetchPdf('SkladPneu/Reports/GetPneuPredavaciProtokolReport', filter);
	}

	getPneuPruvodkaReport(filter: {}) {
		return this.fetchPdf('Sklady/Reports/GetPneuPruvodkaReport', filter);
	}
}

export const apiProvider = new PneuSkladProvider(DMS_MODULE, NAME);
